import React from "react";

const PX = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2957 13.7788C18.7321 14.2152 18.7321 14.9228 18.2957 15.3592C17.8593 15.7956 17.1517 15.7956 16.7153 15.3592L13.2389 11.8828L13.2393 11.882L16.7157 15.3584C17.1521 15.7948 17.1521 16.5024 16.7157 16.9388C16.2793 17.3752 15.5717 17.3752 15.1353 16.9388L14.3453 16.1488L13.5553 18.5192L7.23449 12.1984C5.48889 10.4528 5.48889 7.62319 7.23449 5.87759C8.98009 4.13199 11.8097 4.13199 13.5553 5.87759L19.8761 12.1984C20.3125 12.6348 20.3125 13.3424 19.8761 13.7788C19.4397 14.2152 18.7321 14.2152 18.2957 13.7788ZM18.2957 13.7788L14.8193 10.3024"
        stroke="#215E9B"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.40038 14.1936C7.96398 14.63 7.25638 14.63 6.81998 14.1936C6.38358 13.7572 6.38358 13.0496 6.81998 12.6132L7.42198 12.0112L7.42278 12.0104L8.02478 11.4084C8.46118 10.972 9.16878 10.972 9.60518 11.4084C10.0416 11.8448 10.0416 12.5524 9.60518 12.9888M8.40038 14.1936L9.00238 13.5916M8.40038 14.1936C7.96398 14.63 7.96398 15.3376 8.40038 15.774C8.83678 16.2104 9.54438 16.2104 9.98078 15.774M9.98078 15.774L10.5828 15.172M9.98078 15.774C9.54438 16.2104 9.54438 16.918 9.98078 17.3544C10.4172 17.7908 11.1248 17.7908 11.5612 17.3544M11.5612 17.3544L12.1632 16.7524M11.5612 17.3544C11.1248 17.7908 11.1248 18.4984 11.5612 18.9348C11.9976 19.3712 12.7052 19.3712 13.1416 18.9348L13.7436 18.3328L13.7444 18.332L14.3464 17.73C14.7828 17.2936 14.7828 16.586 14.3464 16.1496C13.91 15.7132 13.2024 15.7132 12.766 16.1496M12.766 16.1496L12.164 16.7516M12.766 16.1496C13.2024 15.7132 13.2024 15.0056 12.766 14.5692C12.3296 14.1328 11.622 14.1328 11.1856 14.5692M11.1856 14.5692L10.5836 15.1712M11.1856 14.5692C11.622 14.1328 11.622 13.4252 11.1856 12.9888C10.7492 12.5524 10.0416 12.5524 9.60518 12.9888M9.60518 12.9888L9.00318 13.5908"
        stroke="#F9C438"
        stroke-miterlimit="10"
      />
      <path
        d="M19.8762 12.1988L15.6678 7.99039C15.3754 7.69799 14.9014 7.69799 14.609 7.99039L13.425 9.17439C12.6734 9.92599 11.519 10.0304 10.6558 9.48679C10.4326 9.34639 10.4138 9.02519 10.6002 8.83879L12.9062 6.53279L13.5582 5.88079L13.555 5.87759C15.3006 4.13199 18.1302 4.13199 19.8758 5.87759C21.6214 7.62319 21.6214 10.4528 19.8758 12.1984L19.8762 12.1988Z"
        stroke="#F9C438"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export default PX;
